<template>
  <div class="page">
    <Search class="search" :conditionInfo="conditionInfo" @searchData="searchData" @reset="reset"></Search>
    <div class="center">
      <div class="listInfo">
        <div style="margin-bottom: 20px">
          <el-input placeholder="申请单编号/商户名称/商户号" v-model="search" class="search-input">
            <el-button slot="append" type="primary" @click="getSearch(search)">搜索</el-button>
          </el-input>
        </div>
        <div class="order">
          <el-popover popper-class="popverClass" placement="bottom-start" trigger="hover">
            <div style="text-align: left; margin: 0">
              <div class="order-number">
                <div style="display: flex; justify-content: space-between">
                  <p class="type">待提交</p>
                  <p>{{ toSubmit }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">待审核</p>
                  <p>{{ toAudit }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">待验证</p>
                  <p>{{ toVerify }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">待签约</p>
                  <p>{{ toSign }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">已驳回</p>
                  <p>{{ rejected }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">已完成</p>
                  <p>{{ finish }}条</p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p class="type">开通权限中</p>
                  <p>{{ openingAuthority }}条</p>
                </div>
              </div>
            </div>
            <p slot="reference" class="view-order">查看关联单据</p>
          </el-popover>
        </div>
      </div>
      <list :applyList="applyList"></list>
      <div class="pagination">
        <Pagination :params="form" @changeSize="changeSize" @changePage="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import Search from '../../components/index/search';
import List from '../../components/index/list';
import { listData, statusNum } from '../../../../api/module/merchants';

export default {
  components: {
    Search,
    List,
  },

  data() {
    return {
      search: '',
      conditionInfo: {
        datePickerModel: [],
        merchantType: '',
        status: '',
      },
      applyList: [
        // {
        //   applymentId: '11111111',
        //   businessLicenseInfoMerchantName: '名称',
        //   subMchid: '22222',
        //   subjectType: '个体商户',
        //   status: '待提交',
        //   contactName: '员工',
        // },
      ],
      form: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      toSubmit: '0', //待提交
      toAudit: '0', //待审核
      toVerify: '0', //待验证
      toSign: '0', //待签约
      rejected: '0', //已驳回
      finish: '0', //已完成
      openingAuthority: '0', //开通权限中
    };
  },
  created() {
    this.listData();
    this.statusNum();
  },
  mounted() {},
  methods: {
    // 修改条数
    changeSize(val) {
      console.log(val);
      this.form.pageSize = val;
      this.listData();
    },
    // 修改页数
    changePage(val) {
      console.log(val);
      this.form.pageNum = val;
      this.listData();
    },
    getSearch(search) {
      console.log(search);
      this.search = search;
      this.listData();
    },
    async listData() {
      const { datePickerModel, merchantType, status } = this.conditionInfo;
      const { pageNum, pageSize } = this.form;
      console.log(datePickerModel);
      const result = await listData({
        startTime: datePickerModel !== null && datePickerModel.length ? datePickerModel[0] + ' 00:00:00' : '',
        endTime: datePickerModel !== null && datePickerModel.length ? datePickerModel[1] + ' 23:59:59' : '',
        merchantType,
        status,
        pageNum,
        pageSize,
        queryInfo: this.search,
      });
      if (result) {
        this.applyList = result.content;
        this.form.total = result.total;
      } else {
        this.applyList = [];
        this.form.total = 0;
      }
      console.log('首页列表数据', result);
    },
    async statusNum() {
      const result = await statusNum({});
      result.forEach((item) => {
        if (result) {
          if (item.status == 0) {
            this.toSubmit = item.count;
          } else if (item.status == 1) {
            this.toAudit = item.count;
          } else if (item.status == 2) {
            this.toVerify = item.count;
          } else if (item.status == 3) {
            this.toSign = item.count;
          } else if (item.status == 4) {
            this.rejected = item.count;
          } else if (item.status == 5) {
            this.finish = item.count;
          } else if (item.status == 6) {
            this.openingAuthority = item.count;
          }
        }
      });
      console.log('首页列表数据', result);
    },
    searchData(val) {
      this.conditionInfo = val;
      this.listData();
    },
    reset() {
      (this.conditionInfo = {
        datePickerModel: [],
        merchantType: '',
        status: '',
      }),
        (this.form = {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        }),
        this.listData();
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 100%;
  background: #f8f8f8;
  .search {
    margin-bottom: 20px;
  }
  .search-input {
    width: 314px;
  }
  .el-input-group__append button.el-button {
    .button--primary(@primary-blue);
    color: @bg-white;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 40px;
  }
  .center {
    background-color: white;
    box-sizing: border-box;
    padding: 20px;
  }
  .listInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order {
    margin-right: 68px;
    .view-order {
      color: #4359b7;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .pagination {
    height: 50px;
    background-color: @bg-white;
    padding-right: 36px;
    .flex_layout(row, flex-end);
  }
}
</style>
